import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EquipoService } from '../../services/equipo.service';
interface RelatedIds {
  id: number;
  id_next: number | null;
  id_prev: number | null;
}
@Component({
  selector: 'app-team-member-block',
  templateUrl: './team-member-block.component.html',
  styleUrls: ['./team-member-block.component.css']
})
export class TeamMemberBlockComponent implements OnInit {

  img: any;

  allMembers: any[] = []



  @Input() teamMemberBlock_item: any = {}
  constructor(private router: Router, private equipoService: EquipoService) { }

  ngOnInit(): void {
    if (this.teamMemberBlock_item.id !== 9999 && this.teamMemberBlock_item.id !== 9998 && this.teamMemberBlock_item.id !== 9997) {
      this.img = 'https://' + this.teamMemberBlock_item.poster
    }
    else {
      this.img = this.teamMemberBlock_item.imgBigUrl
    }
  }

  gotoMember(id) {
    this.equipoService.getTeamMembersItems().subscribe(
      (data) => {
        this.allMembers = data.data.teammates.rows

        // Create next and prev ids
        const myRelatedIds = this.createNextPrev(this.teamMemberBlock_item.id)
        // Set shared data to service
        this.equipoService.setSharedData(myRelatedIds)
        // Navigate to member page
        this.router.navigate(['/equipo', id])
      },
      (err) => { }
    )
  }



  createNextPrev(id: number): RelatedIds | null {
    const index = this.allMembers.findIndex(member => member.id === id);

    if (index === -1) {
      return null; // El miembro con el id proporcionado no existe
    }

    const relatedIds: RelatedIds = {
      id: id,
      id_prev: index > 0 ? this.allMembers[index - 1].id : null,
      id_next: index < this.allMembers.length - 1 ? this.allMembers[index + 1].id : null
    };

    return relatedIds;
  }

}
